import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refund-report',
  templateUrl: './refund-report.component.html',
  styleUrls: ['./refund-report.component.scss']
})
export class RefundReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
